"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EUserRole = exports.EStoryStatus = void 0;
var EStoryStatus;
(function (EStoryStatus) {
    EStoryStatus["PENDING"] = "PENDING";
    EStoryStatus["APPROVED"] = "APPROVED";
    EStoryStatus["REJECTED"] = "REJECTED";
})(EStoryStatus = exports.EStoryStatus || (exports.EStoryStatus = {}));
var EUserRole;
(function (EUserRole) {
    EUserRole["PENDING"] = "PENDING";
    EUserRole["MEMBER"] = "MEMBER";
    EUserRole["ADMIN"] = "ADMIN";
})(EUserRole = exports.EUserRole || (exports.EUserRole = {}));
//# sourceMappingURL=enums.js.map